import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalizedString } from 'app/shared/model/localized-string.model';
import { locale as globalEnglish } from 'assets/i18n/en';
import { locale as globalFrancais } from 'assets/i18n/fr';
import { locale, loadMessages } from 'devextreme/localization';
import enMessages from 'devextreme/localization/messages/en.json';
import frMessages from 'devextreme/localization/messages/fr.json';
import { Subject } from 'rxjs';
import { skip, takeUntil } from 'rxjs/operators';
import { FuseTranslationLoaderService } from './translation-loader.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService implements OnDestroy {

  get currentLang(): string {
    return this.translateService.currentLang;
  }

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateService: TranslateService,
  ) { }

  private unsubscribeAll: Subject<void> = new Subject();
  private readonly defaultLanguage = 'fr';

  localizedVariableValue(localizedString: LocalizedString): string {
    return (this.currentLang === 'fr') ? localizedString?.fr : localizedString?.en;
  }

  changeLocale(data: string) {
    this.setLocale(data);
  }

  getLocale(): string {
    return sessionStorage.getItem('locale') || this.defaultLanguage;
  }

  initLocale() {
    this.translateService.addLangs(['fr', 'en']);
    this.translateService.setDefaultLang(this.defaultLanguage);

    this.fuseTranslationLoaderService.loadTranslations(globalEnglish, globalFrancais);

    this.changeLocale(this.getLocale());

    this.translateService.onLangChange
      .pipe(
        skip(1),
        takeUntil(this.unsubscribeAll))
      .subscribe((params) => {
        this.changeLocale(params.lang);
      });
  }

  setLocale(lang: string) {
    sessionStorage.setItem('locale', lang);
    this.loadDevExtremeMessages(lang);
    locale(lang);
    this.translateService.use(lang);
  }

  private loadDevExtremeMessages(lang: string): void {
    if (lang === 'fr') {
      loadMessages({
        fr: {
          ...frMessages.fr,
          'dxDataGrid-searchPanelPlaceholder': 'Rechercher',
        },
      });
    } else {
      loadMessages(enMessages);
    }
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
